module.exports = __webpack_public_path__ + "assets/img/chirp-notifications.70d29b6c.svg";